import styled from 'styled-components'
import { BoxDefault } from '../../../components/BoxContainer/styles'
import IconUp from '../../../assets/Icons/green-arrow-up.svg'
import IconDown from '../../../assets/Icons/redArrowDown.svg'

export const Wrap = styled.div`
  h1 {
    color: var(--text-tertiary);
    font-size: var(--font-size-md);
    font-weight: lighter;
    margin-bottom: 32px;
  }

  h2 {
    color: var(--text-tertiary);
    font-size: var(--font-size-md);
    font-weight: 800;
  }

  > main {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;

    > div {
      flex: 1;
    }
  }

  .spaceTop {
    margin-top: 40px;
  }
`

export const GrossRevenue = styled(BoxDefault)`
  display: flex;
  flex-direction: column;
  flex: 2;
  max-width: 48rem;
  /* min-height: 100vh; */
`

export const Conversion = styled(BoxDefault)`
  flex: 1;
  /* min-height: 100vh; */
`
export const Icon = styled.i`
  display: inline-block;
  width: 14px;
  height: 14px;
`

export const IcoTotal = styled.div`
  ${Icon} {
    background: ${({ positive }) =>
      positive
        ? `transparent url(${IconUp}) no-repeat center center`
        : `transparent url(${IconDown}) no-repeat center center`};
  }

  span {
    color: var(--theme-green);
    font-size: var(--font-size-sm);
    font-weight: lighter;
  }
`

export const BoxTotal = styled.div`
  h4 {
    color: var(--light-gray);
    font-size: var(--font-size-sm);
    font-weight: lighter;
  }
  h5 {
    color: var(--dark);
    font-size: var(--font-size-xl);
    font-weight: bold;
  }
`

export const BoxGraphic = styled(BoxDefault)`
  flex-wrap: wrap !important;
  align-items: stretch !important;
  justify-content: center !important;

  ${BoxDefault} {
    margin-top: 0px;
  }

  ${GrossRevenue}, ${Conversion} {
    h3 {
      color: var(--text-dark);
      font-size: var(--font-size-lg);
      font-weight: bold;
      margin: 32px 0;
    }
  }
`
